import React from "react";
import { Typography } from "@mui/material";
import Button from "../../../common/Button";

const ChooseGroupOption = ({ handleGroupOptionSelect, onClose }) => {
  return (
    <div>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Are you adding to a new or existing group?
      </Typography>

      <div style={{ display: "flex", flexDirection: "column" }}>
        <Button
          onClick={() => handleGroupOptionSelect("new")}
          text="Upload to a new group"
        />
        <Button
          onClick={() => handleGroupOptionSelect("existing")}
          text="Upload to existing group"
        />
        <Button
          variant="outlined"
          onClick={onClose}
          text="Cancel"
          backgroundColor="white"
        />
      </div>
    </div>
  );
};

export default ChooseGroupOption;
